module.exports = __webpack_public_path__ + "static/media/BANNER-WEBSITE Survey-GETI.5fc51dec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/survey-img/BANNER-WEBSITE Survey-GETI.png
// module id = 573
// module chunks = 0